import React from 'react';
import { Link } from 'react-router-dom';
import {
  ShoppingBag, User, BookOpen, FileText, Phone,
  HelpCircle, Shield, Truck, RotateCcw, Star,
  Award, Home, ChevronRight, Map
} from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './SitemapPage.css';

const SITEMAP = [
  {
    title: 'Main Pages',
    icon: Home,
    color: '#1565C0',
    links: [
      { label: 'Home', href: '/', internal: true },
      { label: 'Shop', href: '/shop', internal: true },
      { label: 'Features', href: '/features', internal: true },
      { label: 'Recipes', href: '/recipes', internal: true },
      { label: 'Contact Us', href: '/contact', internal: true },
    ],
  },
  {
    title: 'Shop',
    icon: ShoppingBag,
    color: '#29ABE2',
    links: [
      { label: 'All Products', href: '/shop', internal: true },
      { label: 'Economy Class', href: '/shop?class=ECONOMY', internal: true },
      { label: 'Business Class', href: '/shop?class=BUSINESS', internal: true },
      { label: 'First Class', href: '/shop?class=FIRST', internal: true },
      { label: 'Cart', href: '/cart', internal: true },
      { label: 'Checkout', href: '/checkout', internal: true },
    ],
  },
  {
    title: 'Account',
    icon: User,
    color: '#10B981',
    links: [
      { label: 'Login', href: '/login', internal: true },
      { label: 'Register', href: '/register', internal: true },
      { label: 'My Dashboard', href: 'https://app.auroragh.com/dashboard', internal: false },
      { label: 'My Orders', href: 'https://app.auroragh.com/dashboard/orders', internal: false },
      { label: 'My Wallet', href: 'https://app.auroragh.com/dashboard/wallet', internal: false },
      { label: 'My Profile', href: 'https://app.auroragh.com/dashboard/profile', internal: false },
    ],
  },
  {
    title: 'Loyalty Program',
    icon: Award,
    color: '#F59E0B',
    links: [
      { label: 'Loyalty & Rewards', href: 'https://app.auroragh.com/dashboard/loyalty', internal: false },
      { label: 'Prize Store', href: 'https://app.auroragh.com/dashboard/prizes', internal: false },
      { label: 'Buy Points', href: 'https://app.auroragh.com/dashboard/wallet/buy-points', internal: false },
      { label: 'Referral & Middleman', href: 'https://app.auroragh.com/dashboard/referral', internal: false },
    ],
  },
  {
    title: 'Recipes',
    icon: BookOpen,
    color: '#8B5CF6',
    links: [
      { label: 'All Recipes', href: '/recipes', internal: true },
      { label: 'Request a Recipe', href: 'https://app.auroragh.com/dashboard/recipes', internal: false },
    ],
  },
  {
    title: 'Support',
    icon: Phone,
    color: '#EF4444',
    links: [
      { label: 'Contact Us', href: '/contact', internal: true },
      { label: 'FAQs', href: '/faq', internal: true },
      { label: 'Live Chat', href: 'https://app.auroragh.com/dashboard/support', internal: false },
    ],
  },
  {
    title: 'Legal & Policies',
    icon: Shield,
    color: '#64748B',
    links: [
      { label: 'Privacy Policy', href: '/privacy-policy', internal: true },
      { label: 'Terms of Service', href: '/terms', internal: true },
      { label: 'Shipping Policy', href: '/shipping-policy', internal: true },
      { label: 'Return Policy', href: '/return-policy', internal: true },
    ],
  },
  {
    title: 'Information',
    icon: FileText,
    color: '#0D2137',
    links: [
      { label: 'About Aurora', href: '/features', internal: true },
      { label: 'FAQ', href: '/faq', internal: true },
    ],
  },
];

const SitemapPage = () => {
  return (
    <>
      <Navbar />
      <div className="sitemap-page">
        {/* Hero */}
        <div className="sitemap-hero">
          <div className="container">
            <div className="sitemap-hero-inner">
              <Map size={32} color="#29ABE2" strokeWidth={1.5} />
              <div>
                <h1 className="sitemap-title">Sitemap</h1>
                <p className="sitemap-subtitle">
                  A complete overview of all pages on Aurora Seafood
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Grid */}
        <div className="container">
          <div className="sitemap-grid">
            {SITEMAP.map((section) => {
              const Icon = section.icon;
              return (
                <div key={section.title} className="sitemap-section">
                  <div className="sitemap-section-header">
                    <div className="sitemap-section-icon" style={{ background: `${section.color}15`, color: section.color }}>
                      <Icon size={18} />
                    </div>
                    <h2 className="sitemap-section-title">{section.title}</h2>
                  </div>
                  <ul className="sitemap-links">
                    {section.links.map((link) => (
                      <li key={link.href}>
                        {link.internal ? (
                          <Link to={link.href} className="sitemap-link">
                            <ChevronRight size={13} color={section.color} />
                            {link.label}
                          </Link>
                        ) : (
                          <a href={link.href} className="sitemap-link" target="_blank" rel="noreferrer">
                            <ChevronRight size={13} color={section.color} />
                            {link.label}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SitemapPage;